import { useCallback } from 'react'
import { Moon, Sun, EyeOff, Eye } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useSnapshot } from 'valtio'
import { store, actions } from '@/store'
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from '@/components/ui/context-menu'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTheme } from '@/components/theme-context'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
export function ModeToggle() {
  const snap = useSnapshot(store)
  const { setTheme } = useTheme()

  const handleThemeClick = useCallback(
    (event) => {
      const nextTheme = event.currentTarget.dataset.theme
      if (nextTheme) {
        setTheme(nextTheme)
        window.record('theme_changed', { theme: nextTheme })
      }
    },
    [setTheme],
  )
  if (!snap.uiSettings.showTheme) return null

  return (
    <div id="theme-selector" className="shrink-0 flex items-center">
      <DropdownMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="icon" className="h-8 w-8">
                <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-transform dark:-rotate-90 dark:scale-0" />
                <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-transform dark:rotate-0 dark:scale-100" />
                <span className="sr-only">Theme</span>
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <p>Toggle theme</p>
          </TooltipContent>
        </Tooltip>
        <DropdownMenuContent align="end">
          <DropdownMenuItem data-theme="light" onClick={handleThemeClick}>
            Light
          </DropdownMenuItem>
          <DropdownMenuItem data-theme="dark" onClick={handleThemeClick}>
            Dark
          </DropdownMenuItem>
          <DropdownMenuItem data-theme="system" onClick={handleThemeClick}>
            System
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
